module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page chat-page"
  }, [_c('v-snackbar', {
    attrs: {
      "timeout": 0,
      "bottom": true,
      "right": true,
      "multi-line": false,
      "vertical": false
    },
    model: {
      value: (_vm.disconnected),
      callback: function($$v) {
        _vm.disconnected = $$v
      },
      expression: "disconnected"
    }
  }, [_vm._v("\n    Connecting...\n  ")]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": 'error',
      "timeout": 5000
    },
    model: {
      value: (_vm.isMessageErr),
      callback: function($$v) {
        _vm.isMessageErr = $$v
      },
      expression: "isMessageErr"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.messageError) + "\n  ")]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.show_requestPopup) ? _c('v-flex', {
    staticClass: "chat-popup requests",
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('div', {
    staticClass: "dismiss-section",
    on: {
      "click": function($event) {
        _vm.show_requestPopup = false
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "popup-section"
  }, [_c('div', {
    staticClass: "requests-section"
  }, [_c('div', {
    staticClass: "header-section"
  }, [_c('p', {
    staticClass: "section-title"
  }, [_vm._v("Attach content to chat")]), _vm._v(" "), _c('div', {
    staticClass: "option-area"
  }, [_c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.request_tab == 'album'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRequestTab('album')
      }
    }
  }, [_vm._v("Album")]), _vm._v(" "), _c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.request_tab == 'merch'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRequestTab('merch')
      }
    }
  }, [_vm._v("Product")]), _vm._v(" "), _c('v-btn', {
    staticClass: "request-option-btn",
    class: {
      selected: _vm.request_tab == 'users'
    },
    nativeOn: {
      "click": function($event) {
        _vm.onRequestTab('users')
      }
    }
  }, [_vm._v("User")])], 1)]), _vm._v(" "), (_vm.request_tab == 'album') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.albums), function(album, index) {
    return _c('div', {
      key: index,
      staticClass: "request-item",
      class: {
        selected: _vm.item_index == index
      },
      on: {
        "click": function($event) {
          _vm.selectItemIndex(index)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (album.cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(album.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(album.user.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.request_tab == 'merch') ? _c('div', {
    staticClass: "content-section"
  }, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: index,
      staticClass: "request-item",
      class: {
        selected: _vm.item_index == index
      },
      on: {
        "click": function($event) {
          _vm.selectItemIndex(index)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: (("background-image: url(" + (product.covers[0].cover.thumb.url) + ")"))
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('label', {
      staticClass: "item-name"
    }, [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('label', {
      staticClass: "user-name"
    }, [_vm._v(_vm._s(product.merchant.username))])])])
  })) : _vm._e(), _vm._v(" "), (_vm.request_tab == 'users') ? _c('div', {
    staticClass: "content-section"
  }, [_c('v-flex', {
    staticClass: "title-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    staticClass: "search-section",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "search-box"
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('span', {
    staticClass: "icon"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_search.svg",
      "width": "20"
    }
  })]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userSearchKeyword),
      expression: "userSearchKeyword"
    }],
    staticClass: "search-field",
    attrs: {
      "type": "search",
      "id": "search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.userSearchKeyword)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.loadUsers()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userSearchKeyword = $event.target.value
      }
    }
  })])])])], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "list-section",
    attrs: {
      "xs12": ""
    }
  }, _vm._l((_vm.users), function(user, index) {
    return _c('v-flex', {
      key: index,
      staticClass: "user-item",
      attrs: {
        "xs12": ""
      },
      on: {
        "click": function($event) {
          if ($event.target !== $event.currentTarget) { return null; }
          _vm.onSelectUser(user)
        }
      }
    }, [_c('div', {
      staticClass: "avatar-image",
      style: ({
        'background-image': 'url(' + user.avatar.thumb.url + ')',
      }),
      on: {
        "click": function($event) {
          _vm.onSelectUser(user)
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "user-name",
      on: {
        "click": function($event) {
          _vm.onSelectUser(user)
        }
      }
    }, [_vm._v("\n                  " + _vm._s(user.username) + "\n                  "), (user.user_type == 'artist') ? _c('v-icon', {
      staticClass: "user-status",
      class: {
        online: user.status == 'active'
      }
    }, [_vm._v("fa-check-circle")]) : _vm._e()], 1)])
  }))], 1) : _vm._e()])])]) : _vm._e()], 1), _vm._v(" "), (_vm.user) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), _c('label', {
    staticClass: "chat-room"
  }, [_vm._v("CHAT ROOM (" + _vm._s(_vm.room.online.length) + ")")]), _vm._v(" "), (_vm.show_stream_live_button) ? _c('v-btn', {
    staticClass: "live-btn px-1",
    attrs: {
      "outline": "",
      "round": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.viewStream()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-circle"
  }), _vm._v(" "), _c('span', {
    staticClass: "live"
  }, [_vm._v("Live")])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.user) ? _c('v-flex', {
    staticClass: "chat-page-content",
    attrs: {
      "xs12": "",
      "sm10": "",
      "offset-sm1": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    staticClass: "chat-content-section",
    attrs: {
      "xs12": "",
      "sm9": "",
      "pa-0": ""
    }
  }, [_c('div', {
    directives: [{
      name: "chat-scroll",
      rawName: "v-chat-scroll",
      value: ({
        always: false,
        smooth: false
      }),
      expression: "{ always: false, smooth: false }"
    }],
    staticClass: "chat-list-section",
    attrs: {
      "id": "msg-container"
    }
  }, [_c('div', {
    staticStyle: {
      "font-weight": "600",
      "margin-left": "8px",
      "font-size": "16px",
      "padding-bottom": "5px"
    }
  }, [_c('P', [_vm._v("\n              Start chatting! Chat conversations are deleted permanently every\n              24 hours. Be respectful.\n            ")])], 1), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": _vm.inset
    }
  }), _vm._v(" "), _c('center', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.disconnected) ? _c('v-progress-circular', {
    staticClass: "progress-circular",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm._l((_vm.reverseMessages), function(message) {
    return _c('div', {
      key: message.id,
      staticClass: "chat-item other"
    }, [_c('div', {
      staticClass: "user-avatar-image",
      style: ('background-color: gray; background-image: url(' +
        (message.fromUser ?
          message.fromUser.avatar.url :
          new String()) +
        ');')
    }), _vm._v(" "), _c('div', {
      staticClass: "chat-section"
    }, [_c('div', {
      staticClass: "info-section"
    }, [_c('router-link', {
      staticClass: "item-user",
      attrs: {
        "to": '/' + message.from
      }
    }, [_vm._v(_vm._s(message.fromUser ? message.fromUser.username : message.from))]), _vm._v(" "), _c('label', {
      staticClass: "messaged-time"
    }, [_vm._v(_vm._s(_vm.moment(message.time).calendar()))])], 1), _vm._v(" "), _c('div', {
      staticClass: "chat-content text"
    }, [(!_vm.isAttachmentLink(message.text)) ? _c('label', {
      staticClass: "text-message"
    }, [_vm._v(_vm._s(message.text))]) : _vm._e(), _vm._v(" "), (_vm.isAlbumLink(message.text) && _vm.albumLinks[message.text]) ? _c('div', {
      staticClass: "album-embed-wrapper"
    }, [_c('activity-album-card', {
      staticClass: "chat-album-embed",
      attrs: {
        "object": _vm.albumLinks[message.text]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info-section"
    }, [_c('router-link', {
      attrs: {
        "to": '/album/' + _vm.albumLinks[message.text].slug
      }
    }, [_c('label', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(_vm.albumLinks[message.text].name))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "item-user",
      attrs: {
        "to": '/' + _vm.albumLinks[message.text].user.slug
      }
    }, [_vm._v(_vm._s(_vm.albumLinks[message.text].user.username))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isMerchLink(message.text) && _vm.merchLinks[message.text]) ? _c('div', {
      staticClass: "album-embed-wrapper"
    }, [_c('activity-product-card', {
      staticClass: "chat-album-embed",
      attrs: {
        "object": _vm.merchLinks[message.text]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "info-section"
    }, [_c('label', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(_vm.merchLinks[message.text].name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "item-user",
      attrs: {
        "to": '/' + _vm.merchLinks[message.text].merchant.slug
      }
    }, [_vm._v(_vm._s(_vm.merchLinks[message.text].merchant.username))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isUserLink(message.text) && _vm.userLinks[message.text]) ? _c('div', {
      staticClass: "album-embed-wrapper"
    }, [_c('activity-user-card', {
      staticClass: "chat-album-embed",
      attrs: {
        "object": _vm.userLinks[message.text]
      }
    }), _vm._v(" "), (!!_vm.userLinks[message.text]) ? _c('div', {
      staticClass: "info-section"
    }, [_c('label', {
      staticClass: "item-title"
    }, [_vm._v(_vm._s(_vm.userLinks[message.text].username))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('router-link', {
      staticClass: "item-user",
      attrs: {
        "to": '/' + _vm.userLinks[message.text].slug
      }
    }, [_vm._v(_vm._s(_vm._f("formatLargeNumber")(_vm.userLinks[message.text].followers)) + "\n                      followers")])], 1) : _vm._e()], 1) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    })])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "send-chat-section"
  }, [(_vm.connected) ? _c('v-btn', {
    staticClass: "show-attachment-box-btn",
    class: {
      selected: _vm.show_broadcastPopup
    },
    nativeOn: {
      "click": function($event) {
        _vm.show_requestPopup = true
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/ic_attach_add.svg",
      "width": "36"
    }
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    ref: "chat",
    staticClass: "chat-input-box",
    attrs: {
      "type": "text",
      "placeholder": "Write a message...",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.sendMessage(_vm.message)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.showEmojiPicker) ? _c('picker', {
    staticClass: "emoji-picker",
    attrs: {
      "title": "Pick your emoji…",
      "emoji": "point_up"
    },
    on: {
      "click": _vm.addEmoji
    }
  }) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "show-emoji-box-btn",
    class: {
      selected: _vm.showEmojiPicker
    },
    nativeOn: {
      "click": function($event) {
        _vm.showEmojiPicker = !_vm.showEmojiPicker
      }
    }
  }, [_c('v-icon', [_vm._v("tag_faces")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "send-chat-btn",
    nativeOn: {
      "click": function($event) {
        _vm.sendMessage(_vm.message)
      }
    }
  }, [_vm._v("Send")])], 1)]), _vm._v(" "), _c('v-flex', {
    staticClass: "requests-section",
    attrs: {
      "xs12": "",
      "sm3": "",
      "pa-0": ""
    }
  }, [(_vm.meberList) ? _c('div', {
    staticClass: "content-section"
  }, [_c('center', [(_vm.disconnected) ? _c('v-progress-circular', {
    staticClass: "progress-circular",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.connected) ? _c('div', {
    staticClass: "member-group"
  }, [_vm._v("MODERATOR")]) : _vm._e(), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, _vm._l((_vm.adminUsers), function(adminUser) {
    return _c('div', {
      key: ("admin-" + (adminUser.username)),
      staticClass: "member-item"
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: ('background-image: url(' + adminUser.avatar.url + ');')
    }), _vm._v(" "), _c('div', {
      staticClass: "memeber-status",
      class: _vm.room.online.indexOf(adminUser.slug) > -1 ?
        'online' :
        _vm.room.idle.indexOf(adminUser.slug) > -1 ?
        'idle' :
        'offline'
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [_c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": '/' + adminUser.slug
      }
    }, [_vm._v(_vm._s(adminUser.username))])], 1)])
  })), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.onlineUsers.length) ? _c('div', {
    key: 'onlineHeader',
    staticClass: "member-group mt-3"
  }, [_vm._v("\n              ONLINE: " + _vm._s(_vm.room.online.length) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.onlineUsers), function(onlineUser) {
    return (_vm.onlineUsers.length) ? _c('div', {
      key: ("online-" + (onlineUser.username)),
      staticClass: "member-item"
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: ('background-image: url(' + onlineUser.avatar.url + ');')
    }), _vm._v(" "), _c('div', {
      staticClass: "memeber-status online"
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [(onlineUser) ? _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": '/' + onlineUser.slug
      }
    }, [_vm._v(_vm._s(onlineUser.username))]) : _vm._e()], 1)]) : _vm._e()
  }), _vm._v(" "), (_vm.idleUsers.length) ? _c('div', {
    key: 'idleHeader',
    staticClass: "member-group mt-3"
  }, [_vm._v("\n              IDLE: " + _vm._s(_vm.room.idle.length) + "\n            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.idleUsers), function(idleUser) {
    return (_vm.idleUsers.length) ? _c('div', {
      key: ("idle-" + (idleUser.username)),
      staticClass: "member-item"
    }, [_c('div', {
      staticClass: "avatar-area"
    }, [_c('div', {
      staticClass: "avatar-image",
      style: ('background-image: url(' + idleUser.avatar.url + ');')
    }), _vm._v(" "), _c('div', {
      staticClass: "memeber-status idle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "detail-area"
    }, [(idleUser) ? _c('router-link', {
      staticClass: "user-name",
      attrs: {
        "to": '/' + idleUser.slug
      }
    }, [_vm._v(_vm._s(idleUser.username))]) : _vm._e()], 1)]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.admin) ? _c('v-menu', {
    staticClass: "settings-menu",
    attrs: {
      "down": "",
      "offset-y": "",
      "nudge-top": -5,
      "close-on-content-click": false
    }
  }, [_c('v-btn', {
    staticClass: "settings-btn",
    attrs: {
      "slot": "activator",
      "round": ""
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "right": ""
    }
  }, [_vm._v("more_horiz")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "settings-list-tile"
  }, [_c('v-list-tile-content', {
    staticClass: "default-menu-item"
  }, [_c('v-list-tile-title', [_vm._v("Allow users to attach content")]), _vm._v(" "), _c('v-switch', {
    staticClass: "pl-3",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.updateSettings()
      }
    },
    model: {
      value: (_vm.room.settings.attachments),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "attachments", $$v)
      },
      expression: "room.settings.attachments"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "settings-list-tile"
  }, [_c('v-list-tile-content', {
    staticClass: "default-menu-item"
  }, [_c('v-list-tile-title', [_vm._v("Allow users to send links")]), _vm._v(" "), _c('v-switch', {
    staticClass: "pl-3",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.updateSettings()
      }
    },
    model: {
      value: (_vm.room.settings.links),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "links", $$v)
      },
      expression: "room.settings.links"
    }
  })], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', {
    staticClass: "settings-list-tile"
  }, [_c('v-list-tile-content', {
    staticClass: "default-menu-item"
  }, [_c('v-list-tile-title', [_vm._v("Enable a character limit")]), _vm._v(" "), _c('v-switch', {
    staticClass: "pl-3",
    attrs: {
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        _vm.updateSettings()
      }
    },
    model: {
      value: (_vm.room.settings.charLimitBool),
      callback: function($$v) {
        _vm.$set(_vm.room.settings, "charLimitBool", $$v)
      },
      expression: "room.settings.charLimitBool"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1) : _vm._e()])], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-50fbef94","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/chat/chat.vue
// module id = 1719
// module chunks = 180